import { CButton, CCol, CForm, CFormLabel, CFormSelect, CRow } from '@coreui/react';
import React, { useEffect, useState } from 'react';
import AxiosInstance from '../Axios';

// Компонент для зміни статусу замовлення
const PreOrdersStatus = (props) => {
    // console.log('PreOrdersStatus props', props);

    const urlApi = '/pre_orders';
    const [status, setStatus] = useState(props.MyData?.status ? props.MyData.status : "created");
    const [isDisabledStatusBtn, setIsDisavledStatusBtn] = useState(false); // чи заблоковувати кнопку для зміни статусу

    // Текст для popup
    const popupTextSuccess = "Статус змінено";
    const popupTextError = "Статус не змінено";

    // Відслідковувати чи заблоковувати кнопку для зміни статусу
    useEffect(() => {
        if (props.MyData?.status === status) {
            setIsDisavledStatusBtn(true);
        } else {
            setIsDisavledStatusBtn(false);
        }
    }, [props.MyData.status, status]);

    // Дані для оновлення замовлення
    const data_response = {
        status: status,
    };

    // Запит на оформлення замовлення
    const updatePreOrder = async () => {
        try {
            const response = await AxiosInstance.put(`${urlApi}/${props.MyData.id}`, data_response);
            // console.log("response", response);
            setIsDisavledStatusBtn(true);
            // Оовити дані замовлення
            props.setMyData(response.data);
            // Popup про успішні зміни
            props.toastifySuccess(popupTextSuccess);
        } catch (error) {
            setIsDisavledStatusBtn(false);
            console.error("Помилка запиту на оформлення замовлення: ", error);
            // Показати повідомлення про помилку
            props.toastifyWarning(popupTextError);
        };
    };

    // Надіслати форму
    const handleSubmit = event => {
        event.preventDefault();
        setIsDisavledStatusBtn(true);
        updatePreOrder();
    };

    return (
        <CForm onSubmit={handleSubmit}>
            <CRow>
                <CCol md={6}>
                    {/* <CFormLabel htmlFor="exampleFormControlInput1">Статус</CFormLabel> */}
                    <select className="form-select" value={status} onChange={(e) => setStatus(e.target.value)} >
                        {
                            props.statusList.map((status) => {
                                return (
                                    <option key={status.value} value={status.value}>{status.label}</option>
                                );
                            })
                        }
                    </select>
                </CCol>
                <CCol md={6} style={{ textAlign: "end" }}>
                    <CButton type="submit" color="success" disabled={isDisabledStatusBtn}>Зберегти</CButton>
                </CCol>
            </CRow >
        </CForm>

        // <hr />
        // <div md={2} className='filter-field mt-md-2'>
        //     {/* <CFormCheck id="exampleFormControlInput8" label="не має категорій" checked={notCategory} onChange={(event) => NoCategory(event)} /> */}
        //     <label>Атрибут</label>
        //     <CFormSelect aria-label="Default select example" onChange={(event) => ChangeAttributeFilter(event)}>
        //         <option value=''>Всі</option>
        //         <option value="1">з атрибутами</option>
        //         <option value="0">без атрибутів</option>
        //     </CFormSelect>
        // </div>
    );
};

export default PreOrdersStatus;